import { Box, List, ListItem, ListItemAvatar, ListItemText, Paper, Popper, ClickAwayListener, Stack, Avatar } from '@mui/material';
import { AllUsersForZonesQuery, } from '@/__generated__/graphql';
import { PageLoader } from '@/components/shared/PageLoader';
import { AssignToMeButton } from './AssignToMeButton';
import { scrollContainerStyles, listItemTextStyles } from './styles';
import { useFeatureFlag } from '@/hooks';

interface AssigneeListProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  zoneId?: string;
  users: AllUsersForZonesQuery['allUsers']
  isLoading: boolean;
  fallbackProfileImage: string;
  onClose: () => void;
  onUserSelect: (userId: string) => void;
  onScroll: (event: React.UIEvent<HTMLDivElement>) => void;
  scrollContainerReference: React.RefObject<HTMLDivElement>;
}

export const AssigneeList = ({
  open,
  anchorEl,
  zoneId,
  users,
  isLoading,
  fallbackProfileImage,
  onClose,
  onUserSelect,
  onScroll,
  scrollContainerReference,
}: AssigneeListProps) => {
  const isAitTaskLead = useFeatureFlag('ait-task-lead');

  return (
    <Popper open={open} anchorEl={anchorEl} placement="bottom-start" sx={{ boxShadow: '0px 2px 8px 0px #0000004D', my: '8px !important', borderRadius: '4px' }}>
      <ClickAwayListener onClickAway={onClose}>
        <Paper elevation={0} sx={{ width: 186 }}>
          <Box sx={{ p: 1, pb: 0 }}>
            {zoneId && <AssignToMeButton zoneId={zoneId} handleCloseUsersMenu={onClose} />}
          </Box>
          {isAitTaskLead &&
            <Box
              ref={scrollContainerReference}
              onScroll={onScroll}
              sx={scrollContainerStyles}
            >
              <List>
                {users.map((user) => (
                  <ListItem
                    key={user.id}
                    component="div"
                    disableGutters
                    onClick={() => onUserSelect(user.id)}
                    sx={{ '&:hover': { backgroundColor: '#F7FAFC' }, cursor: 'pointer', padding: '0px' }}
                  >
                    <ListItemAvatar sx={{ minWidth: 'auto', mr: 2, paddingLeft: '13px' }}>
                      <Avatar
                        src={user.picture || fallbackProfileImage}
                        sx={{ width: 16, height: 16.19 }}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={user.name}
                      sx={listItemTextStyles}
                    />
                  </ListItem>
                ))}
                {isLoading && (
                  <Stack width="100%" alignItems="center">
                    <PageLoader hideProgress variant="sm" flashing />
                  </Stack>
                )}
              </List>
            </Box>
          }
        </Paper>
      </ClickAwayListener>
    </Popper >
  );
};